

import styled from "styled-components";
import AnalyseIntro from "../components/Analyse/AnalyseIntro";
import DrivingGrowth from "../components/Analyse/DrivingGrowth";
import OptimizePerformance from "../components/Analyse/OptimizePerformance";
import TrackCompareGrow from "../components/Analyse/TrackCompareGrow";
import GetStartedRequestDemoSide from "../components/generic/GetStartedRequestDemoSide";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { lightThemeColors } from "../assets/style/colors";
import { ReactComponent as GridAssetIcon } from "../assets/decorations/blueBannerGrid.svg";
import { Helmet } from "react-helmet-async";

const Analyse = () => {

    return (
        <>
            <Helmet>
                <title>
                    Grovs Analyse | Link-Level Insights & Campaign Optimization
                </title>
                <meta
                    name="description"
                    content="Stop guessing and start growing. Grovs Analyse gives you detailed insights into campaigns, links, and users—so you can track, compare, and optimize with confidence."
                />
                <meta
                    name="keywords"
                    content="link analytics, campaign comparison, referral tracking, app growth analytics, Grovs Analyse, user-level insights, mobile attribution, performance tracking"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Grovs Analyse | Link-Level Insights & Campaign Optimization"
                />
                <meta
                    property="og:description"
                    content="Grovs Analyse helps you understand which links and campaigns drive installs, re-engagements, and referrals—so you can make smarter, faster marketing decisions."
                />
                <meta property="og:url" content="https://www.grovs.io/analyse" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Grovs Analyse | Track, Compare, and Grow with Confidence"
                />
                <meta
                    name="twitter:description"
                    content="Get the insights you need to optimize every link, user, and campaign with Grovs Analyse. Start driving real results—faster."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />
            </Helmet>
            <Container>
                <AnalyseIntro />
                <DrivingGrowth />
                <OptimizePerformance />
                <TrackCompareGrow />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.analyseBg}
                    gradientColor={"rgba(91, 104, 223, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{
                        color: lightThemeColors.darkColor,
                        background: lightThemeColors.lightColor,
                    }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={
                        "Stop Wasting Money on Ads That Don’t Work—Optimize Your Ads Today!"
                    }
                    subtitle={
                        "Ready to take control of your ad spend and unlock real growth? Get the insights you need to optimize your ads, cut waste, and drive better results—faster."
                    }
                />
                <TrackingComponent />
            </Container>
        </>
    );
};

export default Analyse;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
